import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=676618b0&scoped=true"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"
import style0 from "./Split.vue?vue&type=style&index=0&id=676618b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676618b0",
  null
  
)

export default component.exports